module.exports = __webpack_public_path__ + "static/Sporting_Grotesque-Bold_web-dcb803af2a1851603c7398976b183857.woff2";